import { css } from "@emotion/css";
import React from "react";
import {
  AriaPopoverProps,
  DismissButton,
  Overlay,
  usePopover,
} from "react-aria";
import { OverlayTriggerState } from "react-stately";

export interface PopoverProps extends Omit<AriaPopoverProps, "popoverRef"> {
  children: React.ReactElement;
  state: OverlayTriggerState;
  popoverRef?: React.RefObject<HTMLDivElement>;
  minPopoverWidth?: number;
  testID?: string;
}

export function Popover({
  minPopoverWidth,
  children,
  state,
  testID = "popover",
  ...props
}: PopoverProps) {
  const ref = React.useRef<HTMLDivElement>(null);
  const { popoverRef = ref } = props;
  const { popoverProps } = usePopover(
    {
      ...props,
      popoverRef,
    },
    state
  );

  return (
    <Overlay>
      <div
        {...popoverProps}
        ref={popoverRef}
        className={css(styles, {
          boxShadow: "var(--shadow-menu)",
          background: "var(--background-base)",
          minWidth: minPopoverWidth ? `${minPopoverWidth}px` : undefined,
        })}
        data-testid={testID}
      >
        {children}
        <DismissButton onDismiss={state.close} />
      </div>
    </Overlay>
  );
}

const styles = css({
  marginTop: "var(--space-2)",
  display: "flex",
  padding: `${"var(--space-2)"} ${"var(--space-1)"}`,
  boxSizing: "border-box",
  borderRadius: "var(--border-radius-2)",
});
